"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'alixcx',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      agentInfo: {},
      total_auditstatus: {},
      total_optionstatus: {},
      list: [],
      listLoading: true,
      listQuery: {
        type: 1,
        page: 1,
        total: 10,
        wx_status: 1
      },
      small_version_status: {}
    };
  },
  computed: {
    siteInfo: function siteInfo() {
      return this.$store.state.user.siteInfo;
    }
  },
  mounted: function mounted() {
    this.agentInfo = window.agentInfo;
    this.getConfigs();
    this.getList();
  },
  methods: {
    /**
     * 模板注解
     */
    renderHeader: function renderHeader(h, _ref) {
      var column = _ref.column,
        $index = _ref.$index;
      return [column.label, h('el-tooltip', {
        props: {
          content: '小程序版本过旧可能会导致出错噢,请尽快更新至最新版本',
          placement: 'top'
        }
      }, [h('span', {
        class: {
          'el-icon-question': true
        }
      })])];
    },
    /**
     * 获取列表
     */
    getConfigs: function getConfigs() {
      var _this = this;
      this.$get('WxOpen/getConfigs', {
        tag: 'wm010006'
      }).then(function (res) {
        _this.new_template_version = res;
      });
    },
    /**
     * 获取列表
     */
    getList: function getList() {
      var _this2 = this;
      var url = 'AlipayMini/getConfigList';
      var listQuery = Object.assign({}, this.listQuery, {
        page: this.listQuery.page - 1
      });
      this.$get(url, this.listQuery).then(function (res) {
        _this2.small_version_status = res.small_version_status;
        _this2.listLoading = false;
        _this2.list = res.list;
        _this2.listQuery.total = res.total;
      }).catch(function () {
        _this2.listLoading = false;
      });
    },
    /**
     * 上传代码
     */
    uploadCode: function uploadCode(row) {
      var _this3 = this;
      var that = this;
      this.$alert('确定将代码到该小程序吗？', '上传代码', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == "confirm") {
            _this3.showLoad();
            _this3.$post('AlipayMini/openMiniVersionUploadRequest', {
              app_id: row.appId,
              mini_agent_id: row.agent_id,
              template_id: row.template_id,
              template_version: _this3.new_template_version
            }).then(function (res) {
              row.templateInfo.status = 'BUILD';
              row.templateInfo.app_version = res.app_version;
              _this3.loadObj.close();
            }).catch(function (err) {
              _this3.loadObj.close();
            });
          }
        }
      });
    },
    showLoad: function showLoad() {
      var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '正在提交~~~';
      this.loadObj = this.$loading({
        lock: true,
        text: '',
        spinner: 'el-icon-loading'
      });
    },
    /**
     * 查询小程序构建版本
     */
    miniVersion: function miniVersion(row) {
      var _this4 = this;
      this.$get('AlipayMini/openMiniVersionBuildQueryRequest', {
        app_id: row.appId,
        app_version: row.templateInfo.app_version
      }).then(function (res) {
        if (res.create_status == 6) {
          row.templateInfo.status = 'INIT';
        } else {
          _this4.$message({
            message: '版本还在构建中',
            type: 'error'
          });
        }
      });
    },
    /**
     * 提交代码审核
     */
    auditMiniCode: function auditMiniCode(row) {
      var _this5 = this;
      this.$message({
        message: '正在提交审核',
        type: 'success'
      });
      this.$post('AlipayMini/openMiniVersionAuditApplyRequest', {
        app_id: row.appId
      }).then(function (res) {
        _this5.$message({
          message: '提交审核成功',
          type: 'success'
        });
        row.templateInfo.status = 'AUDITING';
      });
    },
    /**
     * 刷新审核状态
     */
    refreshAudit: function refreshAudit(row) {
      var _this6 = this;
      this.$get('AlipayMini/openMiniVersionDetailQueryRequest', {
        app_id: row.appId
      }).then(function (res) {
        row.templateInfo.status = res.status;
        if (res.status == 'AUDIT_REJECT') {
          _this6.$message({
            message: "\u5BA1\u6838\u88AB\u9A73\u56DE\u4E86\uFF0C(".concat(res.reject_reason, ")"),
            type: 'error'
          });
        } else {
          _this6.$message({
            message: '刷新状态成功',
            type: 'success'
          });
        }
      });
    },
    /**
     * 生成体验版
     */
    releaseEx: function releaseEx(row) {
      var _this7 = this;
      this.$post('AlipayMini/openMiniExperienceCreateRequest', {
        app_id: row.appId
      }).then(function (res) {
        _this7.viewEx(row);
      });
    },
    /**
     * 查看体验版
     */
    viewEx: function viewEx(row) {
      var _this8 = this;
      this.$get('AlipayMini/openMiniExperienceQueryRequest', {
        app_id: row.appId
      }).then(function (res) {
        if (res.status == 'expVersionPackged') {
          _this8.$alert('<div class="text-center"><img src="' + res.exp_qr_code_url + '" width="250"/></div>', '体验二维码', {
            dangerouslyUseHTMLString: true
          });
        } else if (res.status == 'expVersionPackaging') {
          _this8.$message({
            message: '体验版生成中，请稍等~',
            type: 'success'
          });
        } else {
          _this8.releaseEx(row);
        }
      }).catch(function (err) {
        _this8.releaseEx(row);
      });
    },
    /**
     * 发布代码
     */
    releaseCode: function releaseCode(row) {
      var _this9 = this;
      this.$post('AlipayMini/openMiniVersionOnlineRequest', {
        app_id: row.appId
      }).then(function (res) {
        row.templateInfo.status = 'RELEASE';
        _this9.$message({
          message: '发布成功',
          type: 'success'
        });
      });
    },
    /**
     * 退回开发
     */
    backCode: function backCode(row) {
      var _this0 = this;
      this.$post('AlipayMini/openMiniVersionAuditedCancelRequest', {
        app_id: row.appId
      }).then(function (res) {
        row.templateInfo.status = 'NOT_UPLOAD';
        _this0.$message({
          message: '退回成功',
          type: 'success'
        });
      });
    },
    /**
     * 撤销审核
     */
    backAudit: function backAudit(row) {
      var _this1 = this;
      this.$alert('确定撤销审核吗？', '撤销审核', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          _this1.$post('AlipayMini/openMiniVersionAuditCancelRequest', {
            app_id: row.appId
          }).then(function (res) {
            row.templateInfo.status = 'INIT';
            _this1.$message({
              message: '撤销成功',
              type: 'success'
            });
          });
        }
      });
    },
    /**
     * 删除开发中的版本
     */
    delVersion: function delVersion(row) {
      var _this10 = this;
      this.$prompt('请输入小程序开发版本号', '删除版本', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputType: 'text',
        beforeClose: function beforeClose(action, instance, done) {
          if (action == 'confirm') {
            var value = instance.inputValue;
            _this10.$post('AlipayMini/openMiniVersionDeleteRequest', {
              app_id: row.appId,
              app_version: value
            }).then(function (res) {
              _this10.$message({
                message: '删除成功',
                type: 'success'
              });
              done();
            });
          } else {
            done();
          }
        }
      });
    }
  }
};